module.exports = __webpack_public_path__ + "static/media/logo-apple.ff4e1aa9.svg";